import { Autocomplete, TextField } from '@mui/material';
import { Api as CompaniesApi } from 'further-types/companies';

interface StageSelectorProps {
  id?: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  name: string;
  placeholder?: string;
}

const CompanyStageSelector = ({
  id = 'stageAutocomplete',
  value,
  onChange,
  name,
  placeholder = 'Select stage',
}: StageSelectorProps) => {
  return (
    <Autocomplete
      id={id}
      getOptionKey={(option) => option}
      options={Object.values(CompaniesApi.Stage)}
      filterSelectedOptions
      onChange={(_event, newValue) => {
        onChange(newValue ?? undefined);
      }}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          required
          name={name}
          placeholder={placeholder}
          fullWidth
        />
      )}
    />
  );
};

export default CompanyStageSelector;
